import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { useDynamicHeight } from "@hooks/use-dynamic-height";
/** The top padding for the projects map, in pixels */
const PROJECTS_MAP_TOP_PADDING = 16;
/**
 * Container for the projects map that sets the correct height for the map.
 */
export function ProjectsMapContainer(t0) {
  const $ = _c(10);
  const {
    children,
    heightDeps: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const heightDeps = t2;
  let t3;
  if ($[2] !== heightDeps) {
    t3 = {
      deps: heightDeps
    };
    $[2] = heightDeps;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    ref,
    height
  } = useDynamicHeight(t3);
  let t4;
  if ($[4] !== height) {
    t4 = {
      width: "100%",
      height,
      marginTop: `${PROJECTS_MAP_TOP_PADDING}px`
    };
    $[4] = height;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== ref || $[8] !== t4) {
    t5 = <Box ref={ref} component="div" data-testid="projects-map-container" sx={t4}>{children}</Box>;
    $[6] = children;
    $[7] = ref;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}